import Typography from '@components/std-components/Typography'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import { PRODUCT_OPERATIONS_LOADERS } from '@modules/order/stores/view/List/ListDataStore'
import { ListUIStore } from '@modules/order/stores/view/List/ListUIStore'
import classNames from 'classnames'
import get from 'lodash/get'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import QtyNumberInput from '../../components/QtyNumberInput'
import * as css from './AverageDepth.css'
import { getNumberFromLocale } from '@utils/get-number-form-locale'
import { nav } from '@stores/nav'
import { ListTableView } from '@modules/order/stores/view/List/ListViewTableService'

const AverageDepth: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    const {
      uiStore: { isOrderEditable }
    } = useOrderContext()
    const viewContextVal = useViewContext()
    const { t } = useTranslation()
    const avgDepth = get(rowData, column.field)
    if (!rowData) {
      return <FieldSkeleton />
    }
    const {
      queryParams: { subSection }
    } = nav
    const uiStore = viewContextVal.uiStore as ListUIStore
    const index = rowData?.id
      ? uiStore.dataStore.itemIndexObjectStore.getIndexByKey(rowData.id)
      : null
    const disabled = index
      ? uiStore.dataStore.itemIndexObjectStore.isObjectsDataLoading(
          index,
          index + 1,
          PRODUCT_OPERATIONS_LOADERS.UPDATING_CLIENT_ORDER_DRAFT_QUANTITY
        )
      : false

    const pathToValue =
      subSection === ListTableView.Quantity
        ? 'quantity.doorProducts'
        : 'summary.doorProducts'
    const totalStores = get(rowData, pathToValue)
      ? Object.keys(get(rowData, pathToValue))?.length
      : 0

    return (
      <div
        className={classNames(
          'flex justify-start column align-center text-center',
          css['cell-container']
        )}
      >
        <QtyNumberInput
          id={rowData.id}
          isDecimal={true}
          onChange={e => {
            uiStore.updateSummaryDraftQuantity(
              rowData,
              Math.round(getNumberFromLocale(e.target.value) * totalStores),
              subSection === ListTableView.Quantity && 'quantity'
            )
          }}
          value={avgDepth}
          disabled={disabled || totalStores === 0 || !isOrderEditable}
        />
        {totalStores === 0 && (
          <Typography variant='caption2' classes={css['message']}>
            {t('order.avgDepthStoreMessage', 'Product has not been booked')}
          </Typography>
        )}
      </div>
    )
  })

export default AverageDepth
